import { combineReducers, createStore, EnhancedStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import thunkMiddleware from 'redux-thunk';

import reduxPersistReducer, { ReduxPersistState } from './redux-persist.slice';
import summariesCacheReducer, { SummariesCacheState } from '@/redux/summaries-cache.slice';
import routerHistoryReducer, { RouterHistoryState } from '@/redux/router-history.slice';
import userPreferencesReducer, { UserPreferencesState } from '@/redux/user-preferences.slice';
import bagReducer, { BagState } from '@/fragments/shop-administration/order/create/shared/bag-slice';
import { createPersistedStore } from './redux-persist';
import { bindDevToolsIfNeeded } from './store-enhancers';

/**
 * Root state, containing all reducers states
 */
export interface RootState {
  readonly reduxPersist: ReduxPersistState;
  readonly userPreferences: UserPreferencesState;
  readonly summariesCache: SummariesCacheState;
  readonly routerHistory: RouterHistoryState;
  readonly bag: BagState;
}

/**
 * App reducers
 */
const reducers = combineReducers({
  reduxPersist: reduxPersistReducer,
  userPreferences: userPreferencesReducer,
  summariesCache: summariesCacheReducer,
  routerHistory: routerHistoryReducer,
  bag: bagReducer,
});

/**
 * Creates a regular store, without persitence
 * @returns the store created
 */
const createNonPersistedStore = () => {
  const store = createStore(reducers, bindDevToolsIfNeeded([thunkMiddleware]));

  return store;
};

/**
 * Creates a global store for redux
 * @returns the store created
 */
export const makeStore: () => EnhancedStore = () => {
  if (process.browser) {
    return createPersistedStore(reducers);
  } else {
    return createNonPersistedStore();
  }
};

export default createWrapper(makeStore);
